<!-- 通用选择弹窗组件 -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    append-to-body
    destroy-on-close
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="select-dialog-container">
      <avue-crud
        ref="crud"
        :option="option"
        :table-loading="loading"
        :data="data"
        :page.sync="page"
        :search.sync="query"
        @search-change="searchChange"
        @search-reset="searchReset"
        @refresh-change="refreshChange"
        @current-change="currentChange"
        @size-change="sizeChange"
        @on-load="onLoad"
        @row-dblclick="handleRowDblClick"
        @selection-change="handleSelectionChange"
      >
        <!-- 自定义操作列 -->
        <template slot="menu" slot-scope="{ row }">
          <el-button
            type="text"
            size="small"
            @click="handleSelect(row)"
          >
            {{ selectButtonText }}
          </el-button>
        </template>
      </avue-crud>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :disabled="!selectedRow" @click="handleConfirm">
        确认选择
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";

export default {
  name: "SelectDialog",
  mixins: [crudMixins],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "选择数据",
    },
    width: {
      type: String,
      default: "1200px",
    },
    apiConfig: {
      type: Object,
      required: true,
    },
    option: {
      type: Object,
      required: true,
    },
    selectButtonText: {
      type: String,
      default: "选择",
    },
  },
  data() {
    return {
      dialogVisible: false,
      selectedRow: null,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.onLoad(this.page);
      }
    },
  },
  methods: {
    // 选择行
    handleSelect(row) {
      this.selectedRow = row;
      this.$emit("select", row);
      this.dialogVisible = false;
    },

    // 确认选择
    handleConfirm() {
      if (this.selectedRow) {
        this.$emit("select", this.selectedRow);
        this.dialogVisible = false;
      } else {
        this.$message.warning("请选择一条记录");
      }
    },

    // 行选择变化
    handleSelectionChange(selection) {
      if (selection.length > 0) {
        this.selectedRow = selection[0];
      }
    },

    // 双击行
    handleRowDblClick(row) {
      this.handleSelect(row);
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.selectedRow = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.select-dialog-container {
  ::v-deep .avue-crud__search {
    .el-form-item__label {
      font-weight: 500;
      color: #606266;
    }
  }

  ::v-deep .avue-crud__table {
    .el-table__header th {
      background-color: #fafafa;
      color: #606266;
      font-weight: 500;
    }
    .el-table__row:hover {
      background-color: #f5f7fa;
    }
  }

  ::v-deep .el-tag {
    border-radius: 4px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 500;
  }

  ::v-deep .el-button--text {
    padding: 0 8px;
    margin-right: 0;
    &:hover {
      color: #409eff;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
